module.exports = __webpack_public_path__ + "static/media/kiwami.89212f09.PNG";